import { Component, Input, OnInit } from '@angular/core';
import { CustomInfoboxformModel } from "./custom-infoboxform.model";
import { ICON_TYPE } from "../../../icons/icon.model";

@Component({
  selector: 'app-custom-infoboxform',
  templateUrl: './custom-infoboxform.component.html',
  styleUrls: ['./custom-infoboxform.component.scss'],
  standalone: false
})
export class CustomInfoboxformComponent implements OnInit {

  @Input()
  item: CustomInfoboxformModel;

  @Input()
  visible: boolean;

  iconTypes = ICON_TYPE;

  constructor() { }

  ngOnInit(): void {
  }

}
